module.exports = __webpack_public_path__ + "img/Ai.f13857a3.png";